import React from "react";
import DevicesTable from "./DevicesTable";

const Assigned = () => {
  return <DevicesTable status="assigned" />;
};

export default Assigned;
